import { FC, useContext, useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
} from '../../../../../_metronic/helpers'
import { Notification, NotificationsQueryResponse } from './_models'
import { useQueryRequest } from './QueryRequestProvider'
import { getRequest } from '../../../../../setup/redux/common/cruds'
import { AxiosResponse } from 'axios'

const QueryResponseContext = createResponseContext<Notification>(initialQueryResponse)

type QueryResponseProviderProps = {
  children: React.ReactNode
}

const QueryResponseProvider: FC<QueryResponseProviderProps> = ({ children }) => {
  const { state } = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.NOTIFICATIONS_LIST}-${query}`,
    () => {
      return getRequest(`${process.env.REACT_APP_API_BASE_URL}notifications?${query}`).then(
        (d: AxiosResponse<NotificationsQueryResponse>) => d.data
      )
    },
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: () => {
        return false
      },
    }
  )

  return (
    <QueryResponseContext.Provider value={{ isLoading: isFetching, refetch, response, query }}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const { response } = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data?.notifications || []
}

const useQueryResponseLoading = (): boolean => {
  const { isLoading } = useQueryResponse()
  return isLoading
}

export { QueryResponseProvider, useQueryResponse, useQueryResponseData, useQueryResponseLoading }
